import React from 'react';
import Modal from './CustomModal';
import { Carousel } from 'react-responsive-carousel';
// styles
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import noPhoto from '../images/icons/nophoto.svg';
import crossbutton from '../images/icons/cross-white.svg';
import '../scss/_listingModal.scss';

class fullCarouselModal extends React.Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal = () => {
        this.props.toggle('fullCarouselModal');
    }

    render() {
        const { listing } = this.props;
        if (!listing) return null;
        const externalCloseBtn = <button className="close dyna-close" style={{ zIndex: 1051 }} onClick={() => this.closeModal()}>
            <img src={crossbutton} alt="close" />
        </button>;
        
        const pictureGallery = !listing.ListingPhotosHDsize?.length ?
        <img src={noPhoto} alt="nophoto" />:
        listing.ListingPhotosHDsize.map((obj, i) => {
                const showCaption = listing.ListingPhotosCaptions && listing.ListingPhotosCaptions[i] != null;
                const captionStyle = {
                    display: showCaption ? 'show' : 'none'
                };
                return <div key={i} className='photo-container'>
                    <img src={obj} alt={i} />
                    <p className="legend" style={captionStyle} >{listing.ListingPhotosCaptions?.length > 0 ? listing.ListingPhotosCaptions[i] : ""}</p>
                </div>
            });

        return <Modal modalIsOpen={this.props.modalIsOpen}
            external={externalCloseBtn}
            handleClose={() => this.closeModal()}
            className="dyna-modal modal-xxl mg-top-0 carousel-modal"
            bodyClass="pd-none" >
            <div className="fullCarouselModal">
                <Carousel
                    showIndicators={false}
                    showStatus={false}
                    infiniteLoop={false}
                    dynamicHeight={true}
                    showThumbs={false}>
                    {pictureGallery}
                </Carousel>
            </div>
        </Modal>
    }
}


export default fullCarouselModal;